import type { VisualEffect } from '../tilemap/types';

export class FloatingTextEffect implements VisualEffect {
  private elapsed = 0;
  private readonly duration = 1.5; // seconds
  private readonly text: string;
  private readonly color: string;
  private readonly screenX: number;
  private readonly screenY: number;

  constructor(options: {
    text: string;
    amount: number;
    screenX: number;
    screenY: number;
  }) {
    if (options.amount < 0) {
      // Healing
      this.text = `+${Math.abs(options.amount)}`;
      this.color = '#4ade80'; // green
    } else {
      // Damage
      this.text = `-${options.amount}`;
      this.color = '#f87171'; // red
    }
    this.screenX = options.screenX;
    this.screenY = options.screenY;
  }

  update(deltaSeconds: number): void {
    this.elapsed += deltaSeconds;
  }

  renderOverlay(ctx: CanvasRenderingContext2D): void {
    const progress = Math.min(this.elapsed / this.duration, 1);
    const alpha = 1 - progress;
    const yOffset = -40 * progress; // Float upward 40px

    ctx.globalAlpha = alpha;
    ctx.fillStyle = this.color;
    ctx.font = 'bold 18px Arial, sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(this.text, this.screenX, this.screenY + yOffset);
    ctx.globalAlpha = 1;
  }

  isComplete(): boolean {
    return this.elapsed >= this.duration;
  }
}
